/**
 * Phase 137 → 135D — Shared LiveDot pulse component
 * ---------------------------------------------------
 * Replaces the inline 4+ duplicate ping animations across StreamX surfaces.
 * Used in the hero status pill, stats bar, public wall, stories page.
 */
export default function LiveDot({ size = 2, color = '#ef4444', className = '' }) {
  const px = `${size * 4}px`;
  return (
    <span
      data-testid="livex-live-dot"
      className={`relative inline-flex ${className}`}
      style={{ height: px, width: px }}
    >
      <span
        className="absolute inline-flex h-full w-full animate-ping rounded-full opacity-75"
        style={{ backgroundColor: color }}
      />
      <span
        className="relative inline-flex rounded-full"
        style={{ height: px, width: px, backgroundColor: color }}
      />
    </span>
  );
}
